import { Badge } from '@ipfabric/ui-components/Badge/Badge';
import { RestartService } from 'pages/Support/Status/RestartService';
import type React from 'react';

type Props = {
  canRestart?: boolean;
  discoveryRunning?: boolean;
  label: string;
  status: boolean;
  /** Name of the system (currently Debian systemd) service */
  serviceName: string;
  onServiceRestarted: () => void;
};

export const ServiceStatusRow: React.FC<Props> = (props) => {
  return (
    <div className='flex flex-row gap items-center px py-2xs border-b border-divider'>
      <div className='flex-1 font-semibold'>{props.label}</div>
      <div>
        {props.discoveryRunning === false ? (
          <Badge color='neutral'>No discovery running</Badge>
        ) : (
          <Badge
            color={props.status ? 'success' : 'error'}
            icon={props.status ? 'fa-check-circle' : 'fa-circle-xmark'}
          >
            {props.status ? 'Running' : 'Not running'}
          </Badge>
        )}
      </div>
      {props.canRestart !== false && (
        <RestartService
          serviceName={props.serviceName}
          onServiceRestarted={props.onServiceRestarted}
        />
      )}
    </div>
  );
};
